export const FOUNTAIN_DRINKS = [
  {
    id: 1,
    name: 'Pepsi'
  },
  {
    id: 2,
    name: 'Diet Pepsi'
  },
  {
    id: 3,
    name: 'Pepsi Zero'
  },
  {
    id: 4,
    name: 'Stary Lemon Lime'
  },
  {
    id: 5,
    name: 'Montain Dew'
  },
  {
    id: 6,
    name: 'Brisk Ice Tea'
  },
  {
    id: 7,
    name: 'Tropicana Lemonade'
  },
  {
    id: 8,
    name: 'Gatorade G2 Fruit Punch'
  },
  {
    id: 9,
    name: 'Mug Root Beer'
  },
  {
    id: 10,
    name: 'Dr Pepper'
  }, 
];